export default __webpack_public_path__ + "static/media/opz_logo.dcec6359.svg";